// extracted by mini-css-extract-plugin
module.exports = {"nav":"CreatePoll_nav__2Lkj_","load":"CreatePoll_load__3_hFl"};